import HeaderPage from "../landing/Header";

import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { Box, Button, Container, Grid, Typography } from '@mui/material';

import { useSelector } from "react-redux";

import React, {useState, useEffect} from "react";

import {
    Link
} from "react-router-dom";
const HomeHeaderPage = (props) => {

    const theme = useTheme();
    const [update_profile_settings, set_update_profile_settings] = useState(false)
    const user_attributes = useSelector((state) => {
      return state.authuser.user_attributes
  })

    useEffect(() => {
        console.log((user_attributes['given_name'] && user_attributes['middle_name'] && user_attributes['family_name'])==undefined)
        set_update_profile_settings(!((user_attributes['given_name'] && user_attributes['middle_name'] && user_attributes['family_name'])==undefined))
    })

    return (
    <Container sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Grid container alignItems="center" justifyContent="space-between" spacing={2} sx={{ pt: { md: 0, xs: 8 }, pb: { md: 0, xs: 5 } }}>
        <Grid item xs={12} lg={5} md={6}>
          <Grid container spacing={2} sx={{ pr: 10, [theme.breakpoints.down('md')]: { pr: 0, textAlign: 'center' } }}>
            <Grid item xs={12}>
              <motion.div
                initial={{ opacity: 0, translateY: 550 }}
                animate={{ opacity: 1, translateY: 0 }}
                transition={{
                  type: 'spring',
                  stiffness: 150,
                  damping: 30
                }}
              >
                <Typography
                  variant="h1"
                  color="white"
                  sx={{
                    fontSize: { xs: '1.825rem', sm: '2rem', md: '2.5rem' },
                    fontWeight: 700,
                    lineHeight: { xs: 1.3, sm: 1.3, md: 1.3 }
                  }}
                >
                  <span>Welcome to Ikigai. Let's accomplish the goals you have set.  </span>
                  <Box component="span" sx={{ color: theme.palette.primary.main }}>
                    <span>Start creating value.</span>
                  </Box>
                </Typography>
              </motion.div>
            </Grid>
              {update_profile_settings
            ?<Grid item xs={12}>
              <motion.div
                initial={{ opacity: 0, translateY: 550 }}
                animate={{ opacity: 1, translateY: 0 }}
                transition={{
                  type: 'spring',
                  stiffness: 150,
                  damping: 30,
                  delay: 0.2
                }}
              >
                <Typography
                  variant="h6"
                  component="div"
                  color="white"
                  sx={{
                    fontSize: { xs: '0.875rem', md: '1rem' },
                    fontWeight: 400,
                    lineHeight: { xs: 1.4, md: 1.4 }
                  }}
                >
                  Ikigai is a platform that provides automation, simplification and analytical capabilities to boost productivity.
                    Ikigai is a App partner with Xero and meets the certification requirements of Xero.
                </Typography>
              </motion.div>
            </Grid>
                  : <Grid item xs={12}>
              <motion.div
                initial={{ opacity: 0, translateY: 550 }}
                animate={{ opacity: 1, translateY: 0 }}
                transition={{
                  type: 'spring',
                  stiffness: 150,
                  damping: 30
                }}
              >
                <Typography
                  variant="h6"
                  component="div"
                  color="white"
                  sx={{
                    fontSize: { xs: '0.875rem', md: '1rem' },
                    fontWeight: 400,
                    lineHeight: { xs: 1.4, md: 1.4 }
                  }}
                >
                    <span>Lets get started. </span>
                  <Box component="span" sx={{ color: theme.palette.primary.main }}>
                      First off lets setup your <Link to="/profiles/user/personal">profile.</Link>
                  </Box>
                </Typography>
              </motion.div>
            </Grid>
              }
          </Grid>
        </Grid>
      </Grid>
    </Container>
    )

}

export default HomeHeaderPage;